import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

class CudlinaSelectionNote extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, (event) => {
      const pending = event.promise;
      this.pending = pending;
      pending.then(({ detail }) => {
        if (!this.isConnected || this.pending !== pending || !detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;
        const updated = detail.html.getElementById(this.id);
        if (updated) this.replaceChildren(...Array.from(updated.childNodes, (node) => node.cloneNode(true)));
      }).catch(() => { /* The product form handles failed variant requests. */ });
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}
if (!customElements.get('cudlina-selection-note')) customElements.define('cudlina-selection-note', CudlinaSelectionNote);

class CudlinaRefill extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.querySelector('form')?.addEventListener('submit', (event) => this.add(event));
  }

  async add(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const button = form.querySelector('button');
    if (button.disabled) return;
    const status = form.querySelector('.cu-refill-status');
    const variantId = form.elements.id.value;
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((element) => element.dataset.sectionId))];
    const pending = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }], promise: pending.promise,
    }));
    button.disabled = true;
    status.textContent = '';
    try {
      const currentResponse = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!currentResponse.ok) throw new Error('Please refresh your cart and try again.');
      const currentCart = await currentResponse.json();
      const parent = currentCart.items.find((line) => line.key === this.dataset.parentKey && String(line.variant_id) === this.dataset.kitId);
      if (!parent) throw new Error('Add a matching full kit before adding replacement heads.');
      const duplicate = currentCart.items.some((line) => String(line.variant_id) === variantId && line.parent_relationship?.parent_key === parent.key);
      if (duplicate) throw new Error('These heads are already attached to your kit. Update their quantity in the cart.');
      const body = JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, parent_line_key: parent.key }],
        sections: sections.join(','), sections_url: window.location.pathname,
      });
      const result = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json', 'Content-Type': 'application/json' } });
      const added = await result.json();
      if (!result.ok || added.status) throw new Error(added.description || added.message || 'Unable to add this item. Please try again.');
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Your item was added. Open your cart to review it.');
      const cart = await cartResponse.json();
      pending.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {
        items: cart.items, sections: added.sections, source: 'cudlina-refill', sourceId: form.id,
        itemCount: 1, didError: false,
      }});
      status.textContent = window.Theme?.translations?.added || 'Added to your cart';
    } catch (error) {
      pending.reject(error);
      status.textContent = error.message;
    } finally {
      button.disabled = false;
    }
  }
}
if (!customElements.get('cudlina-refill')) customElements.define('cudlina-refill', CudlinaRefill);
